const RoutePlannerTools = {
  createRouteOptions: function(network, routeObject) {
    var options = {
      selected: false,
      active: network.active,
      route: network.route,
      timeAndDistance: this.createTimeAndDistance(network),
      type: routeObject.type,
      typeDk: routeObject.typeDk,
      name: network.name,
      routeColor: routeObject.routeColor,
      startDate: network.startDate,
      endDate: network.endDate,
      networkId: network.id
    };

    return options;
  },

  createAlternateRouteOptions: function(network, routeObject, alternateRoute) {
    var options = {
      alternateRoute: true,
      selected: false,
      active: network.active,
      route: alternateRoute.route,
      timeAndDistance: this.createTimeAndDistance(alternateRoute),
      type: routeObject.type,
      typeDk: routeObject.typeDk,
      name: alternateRoute.closedPeriod,
      message: alternateRoute.closedMessage,
      routeColor: routeObject.routeColor,
      startDate: network.startDate,
      endDate: network.endDate,
      networkId: network.id
    };

    return options;
  },

  createTimeAndDistance: function(network) {
    var timeAndDistance = network.route.km+' km - '+network.route.time+' min';

    return timeAndDistance;
  },

  checkForRouteDifferences: function(route1, route2) {
    /*console.log(route1);
    console.log(route2);*/
    var routesDifferent = false;
    if(route1.route.routeCoords.geometry.coordinates.length != route2.route.routeCoords.geometry.coordinates.length) {
      routesDifferent = true;
    }
    else {
      for(var i in route1.route.routeCoords.geometry.coordinates) {
        if(route1.route.routeCoords.geometry.coordinates[i][1] != route2.route.routeCoords.geometry.coordinates[i][1]) {
          routesDifferent = true;
        }
      }
    }
    //console.log(routesDifferent);
    return routesDifferent;
  },
};

export default RoutePlannerTools;
